import { render } from "./PagesTab.vue?vue&type=template&id=f816af80&scoped=true"
import script from "./PagesTab.vue?vue&type=script&lang=js"
export * from "./PagesTab.vue?vue&type=script&lang=js"

import "./PagesTab.vue?vue&type=style&index=0&id=f816af80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f816af80"]])

export default __exports__